module.exports = __webpack_public_path__ + "static/images/solution.3f7b24dcf5474b9f6258d9f50e91d421.jpg";